import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-static-label',
  templateUrl: './static-label.component.html',
  styleUrls: ['./static-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaticLabelComponent {
  @Input() text: string;
  @Input() class: string;
}
